<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage delivery boy</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Name">
        <b-input
            type="text"
            v-model="name"
            placeholder="e.g. Jon Doe"
            required>
        </b-input>
      </b-field>
      <b-field label="Contact">
        <b-input
            type="text"
            v-model="contact"
            placeholder="e.g. 918866323155"
            required>
        </b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageDeliveryBoy">Save</button>
    </footer>
  </div>
</template>

<script>
import DeliveryBoysService from "./service";

export default {
  name: "manageDeliveryBoy",

  props: ["city", "boy"],

  created() {
    if (this.boy.docId) {
      let { docId, name, contact, imageUrl } = this.boy;

      this.id = docId;
      this.name = name;
      this.contact = contact;
      this.imageUrl = imageUrl;
    }
  },

  data() {
    return {
      isLoading: false,
      id: null,
      name: null,
      contact: null,
      imageUrl: null
    };
  },

  methods: {
    manageDeliveryBoy() {
      this.isLoading = true;

      DeliveryBoysService.manage(
        this.id,
        this.city,
        this.name,
        this.contact,
        this.imageUrl
      ).then(() => {
        this.isLoading = false;
        this.$toast.open("Saved successfully");
        this.$emit("close");
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/cities/DeliveryBoys/ManageDeliveryBoy.vue